<template>
    <FKBreadCrumb :page="$t('page.messages')" />
    <MessagesView/>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import MessagesView from "@/components/FK/Messages/MessagesView.vue";
import FKBreadCrumb from '@/components/Widgets/BreadCrumb/FKBreadCrumb.vue';

export default defineComponent({
    name: 'MessagesPage',
    components: {
        FKBreadCrumb,
        MessagesView
    }
})
</script>